// extracted by mini-css-extract-plugin
module.exports = {"loadingPage":"index_loadingPage__3O3JG"};